const BREAKPOINT_MOBILE_MAX = 767;

export const isMobile = (width: number): boolean => {
  return width <= BREAKPOINT_MOBILE_MAX;
};
